if( $('.numbers__wrapper__title') ) {
    $(window).on('scroll load', function() {
            let base = 5;
            var delay = base / 35;
            var pixels = base + window.scrollY * delay ;
            $('.numbers__wrapper__title').css({
                'transform': 'translateY(-50%) translateX(-' + pixels + 'px)',
            })
    });
}
